var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfitThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 152,
    viewBox: "0 0 208 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V145C1 148.314 3.68629 151 7 151H201C204.314 151 207 148.314 207 145V7C207 3.68629 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1724 35C67.1215 35 65.459 36.6626 65.459 38.7134V38.7134C65.459 40.7643 67.1215 42.4268 69.1724 42.4268H184.938C186.989 42.4268 188.651 40.7643 188.651 38.7134V38.7134C188.651 36.6626 186.989 35 184.938 35H69.1724Z",
    fill: "#D1D1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1724 48.793C67.1215 48.793 65.459 50.4555 65.459 52.5064V52.5064C65.459 54.5572 67.1215 56.2198 69.1724 56.2198H138.609C140.66 56.2198 142.323 54.5572 142.323 52.5064V52.5064C142.323 50.4555 140.66 48.793 138.609 48.793H69.1724Z",
    fill: "#D1D1D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7134 100.781C20.6626 100.781 19 102.444 19 104.495V104.495C19 106.546 20.6626 108.208 22.7134 108.208H59.6344C61.6853 108.208 63.3478 106.546 63.3478 104.495V104.495C63.3478 102.444 61.6853 100.781 59.6344 100.781H22.7134Z",
    fill: "#E1E1E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1724 62.5859C67.1215 62.5859 65.459 64.2485 65.459 66.2994V66.2994C65.459 68.3502 67.1215 70.0128 69.1724 70.0128H123.868C125.919 70.0128 127.582 68.3502 127.582 66.2994V66.2994C127.582 64.2485 125.919 62.5859 123.868 62.5859H69.1724Z",
    fill: "#D1D1D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1724 76.3789C67.1215 76.3789 65.459 78.0415 65.459 80.0923V80.0923C65.459 82.1432 67.1215 83.8057 69.1724 83.8057H110.18C112.231 83.8057 113.894 82.1432 113.894 80.0923V80.0923C113.894 78.0415 112.231 76.3789 110.18 76.3789H69.1724Z",
    fill: "#D1D1D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3287 114.572C32.2778 114.572 30.6152 116.235 30.6152 118.286V118.286C30.6152 120.337 32.2778 121.999 34.3286 121.999H59.6347C61.6856 121.999 63.3482 120.337 63.3482 118.286V118.286C63.3482 116.235 61.6856 114.572 59.6347 114.572H34.3287Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1724 90.1699C67.1215 90.1699 65.459 91.8325 65.459 93.8833V93.8833C65.459 95.9342 67.1215 97.5968 69.1724 97.5968H78.64C80.6908 97.5968 82.3534 95.9342 82.3534 93.8833V93.8833C82.3534 91.8325 80.6908 90.1699 78.64 90.1699H69.1724Z",
    fill: "#D1D1D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitThumbnail);
export default __webpack_public_path__ + "static/media/profit-thumbnail.c42e92ea10793bc101dbd2fd6688b472.svg";
export { ForwardRef as ReactComponent };